module.exports = __webpack_public_path__ + "img/img10.c8cfbeb4.svg";